export default __webpack_public_path__ + "static/media/111t.cb68d2bc.jpg";